export default __webpack_public_path__ + "static/media/07__o_preview_5.9279ac4b.jpg";